import React from 'react';
import { X, ChevronRight } from 'lucide-react';

const AboutModals = ({ isOpen, onClose, title, content, icon: Icon }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-md transition-opacity duration-500 overflow-y-auto py-4">
      <div
        className="relative bg-white rounded-3xl p-6 sm:p-8 lg:p-10 shadow-2xl max-w-sm sm:max-w-md lg:max-w-lg w-full mx-4 transform transition-all duration-500 ease-out"
        style={{ animation: isOpen ? 'modalFadeIn 0.4s ease-out' : 'modalFadeOut 0.4s ease-out' }}
      >
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0e6d87]/5 to-blue-50/5 opacity-20 pointer-events-none">
          <svg className="absolute top-0 left-0 w-full h-full opacity-50" viewBox="0 0 60 60" preserveAspectRatio="none">
            <path d="M30 0L0 30l30 30 30-30L30 0z" fill="#0e6d87" fillOpacity="0.02" />
          </svg>
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-[#0e6d87] transition-colors duration-200 z-10"
          aria-label="Close modal"
        >
          <X className="w-5 h-5 sm:w-6 sm:h-6" />
        </button>

        {/* Modal Header */}
        <div className="flex items-center mb-6 animate-fade-in-up">
          {Icon && (
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-r from-[#0e6d87] to-blue-600 rounded-xl flex items-center justify-center mr-3 sm:mr-4 animate-pulse-slow">
              <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </div>
          )}
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">{title}</h2>
        </div>

        {/* Modal Content */}
        <div className="text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed mb-6 animate-fade-in-up animation-delay-100">
          {content}
        </div>

        {/* Action Button */}
        <div className="flex justify-end animate-fade-in-up animation-delay-200">
          <button
            onClick={onClose}
            className="inline-flex items-center px-4 py-2 sm:px-6 sm:py-3 bg-gradient-to-r from-[#0e6d87] to-blue-600 text-white text-sm sm:text-base font-semibold rounded-xl hover:shadow-lg transform hover:scale-105 transition-all duration-300"
          >
            Close
            <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
          </button>
        </div>

        {/* Modal Animation Styles */}
        <style jsx>{`
          @keyframes modalFadeIn {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
          @keyframes modalFadeOut {
            from {
              opacity: 1;
              transform: scale(1);
            }
            to {
              opacity: 0;
              transform: scale(0.9);
            }
          }
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes pulseSlow {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
          }
          .animate-fade-in-up {
            animation: fadeInUp 0.5s ease-out forwards;
          }
          .animate-pulse-slow {
            animation: pulseSlow 2s infinite ease-in-out;
          }
          .animation-delay-100 {
            animation-delay: 0.1s;
          }
          .animation-delay-200 {
            animation-delay: 0.2s;
          }
        `}</style>
      </div>
    </div>
  );
};

export default AboutModals;